import React from "react";
import { Table, TableBody, TableCell, TableRow, TableHead, Typography } from "@material-ui/core";
export class ReportTotalTable extends React.Component {
    render() {
        return (
            <Table className={this.props.classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell component="th" scope="row">
                            <Typography variant="body2">
                                <b>Total</b>
                            </Typography>
                        </TableCell>
                        {Object.keys(this.props.totalRep).map(i => {
                            return (
                                <TableCell
                                    component="th"
                                    scope="row"
                                    key={`${this.props.totalRep[i].title}_${i}`}
                                >
                                    <Typography variant="body2">
                                        <b>{this.props.totalRep[i].title}</b>
                                    </Typography>
                                </TableCell>
                            );
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row">
                            <Typography variant="body2">
                                <b>{this.props.getTotalfromArr(this.props.totalRep)}</b>
                            </Typography>
                        </TableCell>
                        {Object.keys(this.props.totalRep).map(i => {
                            return (
                                <TableCell component="th" scope="row" key={i}>
                                    <Typography variant="body1">
                                        {this.props.totalRep[i].total}
                                    </Typography>
                                </TableCell>
                            );
                        })}
                    </TableRow>
                </TableBody>
            </Table>
        );
    }
}
